module.exports = __webpack_public_path__ + "static/media/StarFill.3a935068.svg";